import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeSupportQuestionsResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeSupportQuestionsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeSupportQuestionsSchema>
type Response = DataResponseWithPagination<
  z.infer<typeof BackofficeSupportQuestionsResponseDataSchema>
>
type OnSuccessFn = (data: Response) => void

const getBackofficeSupportQuestionsQueryKey = (query?: Query) =>
  ["backofficeSupportQuestions", query].filter((e) => e)

type Props = {
  query: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeSupportQuestionsQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeSupportQuestionsQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/support/questions", {
        params: query,
      })
      onSuccess?.(data)
      return data.data
    },
  })
}
